import {Component, OnInit, ChangeDetectorRef, ChangeDetectionStrategy, OnDestroy} from '@angular/core';
import {UsersService} from 'src/app/modules/shared/services/users.service';
import {Constants} from 'src/app/modules/shared/config/constants.config';
import {ThemeService} from '../../../shared/services/theme.service';
import {AppLoadingEventsEmitter} from '../../../shared/events/loading.events';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthService} from '../../../shared/services/auth.service';
import {MasterService} from '../../../shared/services/master.service';
import {UserProfileViewModel} from '../../../shared/viewModels/userProfile.viewModel';

@Component({
    selector: 'app-master-meals',
    templateUrl: './meals.component.html',
    styleUrls: ['./meals.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MealsComponent implements OnInit, OnDestroy {
    user: UserProfileViewModel;

    constructor(
        private readonly usersService: UsersService,
        private readonly changeDetectorRef: ChangeDetectorRef,
        public readonly themeService: ThemeService,
        public readonly constants: Constants,
        public readonly router: Router,
        private readonly route: ActivatedRoute,
        private readonly masterService: MasterService,
        private readonly appLoadingEventsEmitter: AppLoadingEventsEmitter,
        private readonly authService: AuthService,
    ) {
    }

    ngOnInit() {
        this.route.params.subscribe(params => {
            this.masterService.getUserProfile(params['id']).subscribe(user => {
                this.user = user;
                this.changeDetectorRef.detectChanges();
            });
        });
    }

    ngOnDestroy() {
    }

    openUserMeals(profile: UserProfileViewModel) {
        this.masterService.masterLogin(profile.id).subscribe(token => {
            this.authService.setStorageItem('original_logged_token', this.authService.getJWT());
            this.authService.setStorageItem('master_sub_profile_logged_token', token.token);

            // this.authService.setJWT(this.authService.getStorageItem('master_sub_profile_logged_token'));

            this.router.navigate(['/master/meals', profile.id]);
        });
    }

    openMessages(profile: UserProfileViewModel) {
        this.router.navigate(['/master/messages', profile.id]);
    }

}
